import { Card, CardTitle } from "../../components/Card"
import { TextArea } from "../../components/Form"
import { Button } from "../../components/Button"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { FilterModal } from "../DashboardScreen"
import { useScope } from "../../container/SelectProjectCompanyContainer"
import { useDWOptions } from "../../core/utils/hooks/useDwOptions"

function ReportsScreen({
  modalIsOpen,
  setModalIsOpen,
  usersTraining,
  usersSupplier,
  usersByProject,
  exportForms,
  value,
  onChange,
  loading,
  hideDownloadOptions,
}) {
  const { projectsByScope } = useScope()
  const [values, setValues] = useState({})
  const [dw, reload] = useDWOptions()

  useEffect(() => {
    if (projectsByScope && projectsByScope.length) {
      setValues((values) => ({ ...values, projects: projectsByScope.map(row => ({ value: row?.id, label: row?.description }))}));
    }
  }, [projectsByScope])

  const onChangeValues = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const { control } = useForm({
    mode: "onBlur",
  })

  return (
    <></>
    // <div className="report-screen engagement">
    //       <div className="report-screen-engagement-cards">
    //         { !hideDownloadOptions && 
    //           <>
    //             <Card className="report-screen-engagement-card">
    //               <CardTitle className="flex-start" title="Relatório de Fornecedores" />
    //               <div className="report-screen-engagement-card__button">
    //                 <Button label="Baixar" color="orange" handleClick={() => usersSupplier()} />
    //               </div>
    //             </Card>
    //             <Card>
    //               <CardTitle className="flex-start" title="Relatório de Engajamento" />
    //               <div className="report-screen-engagement-card__button">
    //                 <Button label="Baixar" color="orange" handleClick={() => usersByProject()} />
    //               </div>
    //             </Card>
    //           </> 
    //         }
    //         <FilterModal
    //           {...{
    //             useProjects: true,
    //             modalIsOpen,
    //             setModalIsOpen,
    //             onChange: onChangeValues,
    //             control,
    //             reload,
    //             onSearch: () => exportForms(values),
    //             loading,
    //             dw,
    //             values,
    //           }}
    //         />
    //       </div>
    //       { !hideDownloadOptions && 
    //         <div className="card-table">
    //           <Card>
    //             <CardTitle className="flex-start" title="Tabela de Treinados" />
    //             <TextArea
    //               placeholder="Descrição do Projeto"
    //               type="text"
    //               width={"100%"}
    //               max={255}
    //               value={value}
    //               onChange={onChange}
    //               resize="none"
    //             />
    //             <div className="card-description__button">
    //               <Button label="Baixar" color="orange" handleClick={() => usersTraining()} />
    //             </div>
    //           </Card>
    //         </div>
    //       }
    // </div>
  )
}

export default ReportsScreen
